













































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import ContactWorkerDto from '@/models/ContactWorkers/ContactWorkerDto';

@Component({
  name: 'ContactWorkersList',
  components: {  }
})
export default class extends GiganautVue {

    blockingDialog = false;
    editIsBlocking = true;
    editContactWorkerId = '';

    async beforeMount() {
       await ContactDetailsModule.getWorkers();
    }

    async navigateToWorker(workerId: string) {
        this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: workerId } });
    }

    async navigateToSpecOut(specOutId: string) {
        this.$router.push({ name: PageNames.AgencySpecOutDetails, params: { specoutid: specOutId } });
    }

    openBlockingDialog(item: ContactWorkerDto) {
        this.editContactWorkerId = item.id;
        this.editIsBlocking = item.isBlocking;
        this.blockingDialog = true;
    }

    async saveBlocking() {
        await ContactDetailsModule.updateContactWorkerIsBlocking({
            id: this.editContactWorkerId,
            isBlocking: this.editIsBlocking,
        });
        this.blockingDialog = false;
    }

    get loading() {
        return ContactDetailsModule.loadingWorkers;
    }

    get workers() {
        return ContactDetailsModule.workers;
    }

    private headers = [
        { text: 'Name' },
        { text: 'Owner' },
        { text: 'Blocking' },
        { text: 'Sent At'  },
        { text: 'Spec Out' },
    ]
}
